import type { TrendConditionStore } from '@/trendData/trendCondition.store';
import type { TrendScalarStore } from '@/trendData/trendScalar.store';
import type { TrendSeriesStore } from '@/trendData/trendSeries.store';

export const DEFAULT_FORMULA_PANEL_HEIGHT = 575;
export const MIN_FORMULA_PANEL_HEIGHT = 420;
export const MIN_FORMULA_PANEL_WIDTH = 850;
export const FORMULA_HOME = '/formulas/docs/Seeq/index';
export const FORMULA_LIST = 'Formula List';
export const SEARCH = 'search';
export const DOCUMENTATION = 'documentation';
export const ASSISTANT = 'assistant';
export let FORMULA_TOOL_TREND_STORES: [TrendScalarStore, TrendConditionStore, TrendSeriesStore];
export const FORMULA_HELP_WIDTH = 400;
